import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "src/config/apiBase";
import { decryptToken } from "../utils/getToken";
import { toast } from "react-toastify";
import { GitMerge } from "lucide-react";

const CrmDuplicatePanel = () => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [merging, setMerging] = useState(null);
  const url = API_BASE_URL;
  const token = decryptToken("accessToken") || "";

  const load = () => {
    setLoading(true);
    fetch(`${url}/leads/duplicates`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.json() : { groups: [] }))
      .then((res) => setGroups(res.groups || []))
      .catch(() => setGroups([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, [url, token]);

  const mergeGroup = async (group) => {
    const primary = group.leads[0];
    const mergeIds = group.leads.slice(1).map((l) => l.id);
    if (!mergeIds.length) return;

    setMerging(primary.id);
    try {
      const res = await fetch(`${url}/leads/merge`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ primaryId: primary.id, mergeIds }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Merge failed");
      toast.success(`Merged ${data.mergedCount} duplicate(s) into #${primary.id}`);
      load();
    } catch (err) {
      toast.error(err.message || "Could not merge");
    } finally {
      setMerging(null);
    }
  };

  if (loading) return <p className="crm-insights__muted">Scanning for duplicates…</p>;

  return (
    <div className="crm-duplicates">
      <div className="crm-integrations__head">
        <strong>
          <GitMerge size={16} style={{ verticalAlign: "middle", marginRight: 6 }} />
          Duplicate leads
        </strong>
        <button type="button" onClick={load}>
          Refresh
        </button>
      </div>
      <p className="crm-insights__muted" style={{ marginBottom: 12 }}>
        Same mobile number across multiple enquiries. Merge keeps the oldest lead and archives the rest.
      </p>
      {!groups.length ? (
        <p className="crm-insights__muted">No duplicate mobile numbers found.</p>
      ) : (
        groups.map((group) => (
          <div key={group.mobileKey} className="crm-duplicates__group">
            <div className="crm-duplicates__head">
              <span>
                <strong>{group.mobile}</strong> — {group.count} enquiries
              </span>
              <button
                type="button"
                disabled={merging === group.leads[0].id}
                onClick={() => mergeGroup(group)}
              >
                {merging === group.leads[0].id ? "Merging…" : "Merge all"}
              </button>
            </div>
            <ul>
              {group.leads.map((l) => (
                <li key={l.id}>
                  #{l.id} · {l.name || "Unnamed"} · {l.extra || "Uncontacted"} ·{" "}
                  {l.source || l.enquiry_source || "Unknown"}
                </li>
              ))}
            </ul>
          </div>
        ))
      )}
    </div>
  );
};

export default CrmDuplicatePanel;
